import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import DialogContent from './DialogContent';
import { AskAIContextProvider } from '@/context/AskAiContext';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';

export const AskAiDrawer = () => {
	const dispatch = useDispatch();

	const dialogs = useSelector((state) => state.dialog?.open);

	const dialogOpen = useSelector((state) => state.dialog?.open?.askAi) ?? false;

	const otherDialogsOpen = useMemo(() => {
		const otherDialogs = Object.entries(dialogs).filter(
			([dialogName, isOpen]) => isOpen && dialogName !== 'askAi',
		);
		return otherDialogs.length > 0;
	}, [dialogs]);

	const { getFeatureFlags } = useFeatureFlagContext();
	const useAskAiFeature = Boolean(getFeatureFlags('useAskAi')?.active);

	const open = useMemo(() => useAskAiFeature && dialogOpen, [useAskAiFeature, dialogOpen]);

	const handleClose = () => {
		if (otherDialogsOpen) return;
		dispatch(closeDialog('askAi'));
	};

	return (
		<FolioDrawer
			open={open}
			onClose={handleClose}
			size='narrow'
			canMaximise
			blurBackdrop
			slotProps={{ content: { sx: { pb: 2 } } }}
		>
			{open && (
				<AskAIContextProvider>
					<DialogContent />
				</AskAIContextProvider>
			)}
		</FolioDrawer>
	);
};

export default AskAiDrawer;
